import React from "react";
import { AlertTriangle, X, Radio } from "lucide-react";
import { CATEGORY_STYLE } from "../lib/api";

export default function EmergencyModal({ file, onCancel, onConfirm }) {
  if (!file) return null;
  const style = CATEGORY_STYLE[file.category] || CATEGORY_STYLE.General;

  return (
    <div data-testid="emergency-modal" className="fixed inset-0 z-50 bg-black/92 flex items-center justify-center p-6">
      <div className="w-full max-w-2xl bg-[#18181B] border-2 rounded-3xl p-8"
           style={{ borderColor: style.bg }}>
        <div className="flex items-center gap-3 mb-6" style={{ color: style.bg }}>
          <AlertTriangle className="w-12 h-12" />
          <span className="font-display font-black text-2xl tracking-wide">CONFIRM ACTIVATION</span>
        </div>

        <div className="text-center mb-8">
          <p className="text-[#A1A1AA] font-bold text-lg tracking-wide mb-2">PLAY {style.label} RECORDING?</p>
          <h2 className="font-display font-black text-4xl md:text-5xl text-white tracking-tight">
            {file.name.toUpperCase()}
          </h2>
          {file.description ? <p className="text-[#71717A] mt-3 text-base">{file.description}</p> : null}
        </div>

        <p className="text-center text-[#71717A] text-sm mb-6">
          This will immediately override any playing music.
        </p>

        <div className="grid grid-cols-2 gap-4">
          <button
            data-testid="emergency-cancel"
            onClick={onCancel}
            className="h-24 rounded-2xl bg-[#27272A] text-white font-display font-black text-2xl tracking-wide flex items-center justify-center gap-3 active:scale-95 transition-transform duration-75 border border-white/10"
          ><X className="w-8 h-8" /> CANCEL</button>
          <button
            data-testid="emergency-confirm"
            onClick={onConfirm}
            className="h-24 rounded-2xl font-display font-black text-2xl tracking-wide flex items-center justify-center gap-3 active:scale-95 transition-transform duration-75"
            style={{ background: style.bg, color: style.text }}
          ><Radio className="w-8 h-8" /> PLAY NOW</button>
        </div>
      </div>
    </div>
  );
}
